var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticStyle: { padding: "20px", overflow: "auto" }
    },
    [
      _c("ul", { staticClass: "List-headr" }, [
        _c(
          "li",
          [
            _c("el-date-picker", {
              attrs: {
                size: "small",
                "value-format": "yyyyMMdd",
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                clearable: false,
                "picker-options": _vm.expireTimeOption
              },
              on: { change: _vm.getData },
              model: {
                value: _vm.time,
                callback: function($$v) {
                  _vm.time = $$v
                },
                expression: "time"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "el-radio-group",
              {
                attrs: { size: "small" },
                on: { change: _vm.getData },
                model: {
                  value: _vm.flowStatisType,
                  callback: function($$v) {
                    _vm.flowStatisType = $$v
                  },
                  expression: "flowStatisType"
                }
              },
              [
                _c("el-radio-button", { attrs: { label: 1 } }, [
                  _vm._v("站点/APP")
                ]),
                _vm._v(" "),
                _c("el-radio-button", { attrs: { label: 2 } }, [
                  _vm._v("流量类型")
                ]),
                _vm._v(" "),
                _c("el-radio-button", { attrs: { label: 3 } }, [
                  _vm._v("代码位")
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _vm.flowStatisType === 1
              ? _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入站点/APP" },
                  model: {
                    value: _vm.queryAppSiteId,
                    callback: function($$v) {
                      _vm.queryAppSiteId = $$v
                    },
                    expression: "queryAppSiteId"
                  }
                })
              : _vm.flowStatisType === 3
              ? _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入代码位" },
                  model: {
                    value: _vm.querySlotId,
                    callback: function($$v) {
                      _vm.querySlotId = $$v
                    },
                    expression: "querySlotId"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.getData }
              },
              [_vm._v("查询")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "house_chart" }, [
        _c("div", {
          style: { width: "100%", height: "400px" },
          attrs: { id: "myChart" }
        }),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.lineData, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                class: [_vm.lineIndex.indexOf(item.id) > -1 ? "c118DEE" : ""],
                on: {
                  click: function($event) {
                    return _vm.setLine(item)
                  }
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("ul", { staticClass: "List-headr" }, [
            _c(
              "li",
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    on: { change: _vm.getData },
                    model: {
                      value: _vm.createDayFlag,
                      callback: function($$v) {
                        _vm.createDayFlag = $$v
                      },
                      expression: "createDayFlag"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "" } }, [
                      _vm._v("时间段")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "1" } }, [
                      _vm._v("日")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticStyle: { float: "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.setExport }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              this.flowStatisType === 1
                ? _c("el-table-column", {
                    key: "1",
                    attrs: {
                      prop: "appSiteId",
                      label: "站点/APP",
                      width: "200"
                    }
                  })
                : this.flowStatisType === 2
                ? _c("el-table-column", {
                    key: "2",
                    attrs: {
                      prop: "flowTypeText",
                      label: "流量类型",
                      width: "150"
                    }
                  })
                : this.flowStatisType === 3
                ? _c("el-table-column", {
                    key: "3",
                    attrs: { prop: "slotId", label: "代码位", width: "150" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                key: "4",
                attrs: { prop: "createDay", label: "日期", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "5",
                attrs: { prop: "reqNum", label: "请求量", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "6",
                attrs: { prop: "bidNum", label: "竞价参与量", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "7",
                attrs: {
                  prop: "bidSuccessNum",
                  label: "竞价成功量",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "8",
                attrs: {
                  prop: "bidJoinRatio",
                  label: "竞价参与率(%)",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "9",
                attrs: {
                  prop: "bidSuccessRatio",
                  label: "竞价成功率(%)",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "10",
                attrs: { prop: "showNum", label: "展现量", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "11",
                attrs: { prop: "clickNum", label: "点击量", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "12",
                attrs: { prop: "clickRatio", label: "点击率(%)", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "13",
                attrs: { prop: "income", label: "收入", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "14",
                attrs: { prop: "cpc", label: "CPC", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "15",
                attrs: { prop: "cpm", label: "CPM", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "16",
                attrs: { prop: "activateNum", label: "转化量", width: "150" }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4ae962", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4ae962","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chart/flow.vue
// module id = 1KvY
// module chunks = 1